import { styled } from "styled-components";

import { UITagButton } from "common/components";
import { useDispatch, useSelector } from "common/utilities/react-redux";
import { useTrack } from "common/utilities/useTrack";
import { useTranslate } from "common/utilities/useTranslate";
import type { TrackMeta } from "domains/analytics/types";
import { toggleTopicMachineTranslation } from "entities/topics/actions";
import { getIsMachineTranslationsOffForTopic } from "entities/topics/selectors";
import type { Topic } from "entities/topics/types";

const StyledTag = styled(UITagButton)`
  font-size: 0.9rem;
`;

type MachineTranslationLabelProps = { keyIssue?: Topic; topic: Topic };

export const MachineTranslationLabel = ({ topic, keyIssue }: MachineTranslationLabelProps) => {
  const dispatch = useDispatch();
  const isMachineTranslationOff = useSelector(getIsMachineTranslationsOffForTopic(topic.id));
  const track = useTrack();
  const translate = useTranslate();

  const labelTerm = isMachineTranslationOff ? "app.machine_translations_off" : "app.machine_translated";

  const toggleMachineTranslationsHandle = () => {
    if (topic) {
      dispatch(toggleTopicMachineTranslation({ id: topic.id }));
      let event: TrackMeta = {
        name: isMachineTranslationOff ? "Machine translation On" : "Machine translation Off",
        page: "Topic detail",
        entityId: topic.id,
        entityName: topic.name,
        entityType: "Topic",
      };
      if (keyIssue) {
        event = {
          ...event,
          secondaryEntityId: keyIssue.id,
          secondaryEntityName: keyIssue.name,
          secondaryEntityType: "Topic",
        };
      }
      track(event);
    }
  };

  return topic.is_machine_translated ? (
    <StyledTag onClick={toggleMachineTranslationsHandle}>{translate(labelTerm)}</StyledTag>
  ) : null;
};
